import Link from "next/link";
import Image from "next/image";
import gommaCarboncinoLogo from "@public/gomma-carboncinoSBS.jpg";

const ScopriBsGommaCarboncino = ({ post, index }) => {
  return (
    <div
      key={index}
      className="flex flex-col items-center justify-center py-2 pl-10 max-md:!mt-0 max-md:ms-4 max-md:pr-4"
    >
      <Image
        className="mb-10"
        src={gommaCarboncinoLogo}
        width={500}
        height={400}
        alt={post.name}
      ></Image>

      <Link
        className="bg-orange px-10 py-4 uppercase text-white md:px-20"
        href={`/c/${post.slug}`}
      >
        Scopri
      </Link>
    </div>
  );
};

export default ScopriBsGommaCarboncino;
